import { useEffect, useState } from "react";
import { api, fmtBRL } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";

export function ReguaPreviaDialog({ open, onOpenChange }) {
  const [itens, setItens] = useState(null);

  useEffect(() => {
    if (!open) return;
    setItens(null);
    api.get("/whatsapp/regua/previa").then(({ data }) => setItens(data.itens)).catch(() => setItens([]));
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-sm max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="regua-previa-dialog">
        <DialogHeader><DialogTitle>Simulação — mensagens de hoje (nada é enviado)</DialogTitle></DialogHeader>
        {itens === null && <div className="text-sm text-muted-foreground">Calculando...</div>}
        {itens?.length === 0 && (
          <div className="text-center py-8 text-sm text-muted-foreground border border-dashed rounded-sm" data-testid="regua-previa-vazia">
            Nenhuma mensagem programada para hoje.
          </div>
        )}
        <div className="space-y-3">
          {itens?.map((i) => (
            <div key={`${i.boleto_id}-${i.tipo}`} className="border border-border rounded-sm p-3" data-testid={`regua-previa-item-${i.boleto_id}`}>
              <div className="flex items-center justify-between gap-2 flex-wrap">
                <div className="flex items-center gap-2 min-w-0">
                  <Badge variant="outline" className="text-[10px] uppercase tracking-widest">{i.tipo}</Badge>
                  <span className="text-sm font-semibold break-anywhere">{i.razao_social}</span>
                </div>
                <span className="text-xs font-mono text-muted-foreground">{i.telefone || "sem telefone"}</span>
              </div>
              <div className="text-xs mt-2 font-mono">
                Original {fmtBRL(i.valor_original)} · Atualizado <b>{fmtBRL(i.valor_atualizado)}</b>
              </div>
              <pre className="text-xs mt-2 whitespace-pre-wrap font-sans leading-relaxed text-muted-foreground break-anywhere">{i.mensagem}</pre>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
